import { useSuspenseQuery } from '@apollo/client';
import {
  type OnBoardingQuery,
  type OnBoardingQueryVariables,
  type Step4,
  QUERY_ONBOARDING,
} from '@edwin-group/cj-graphql';
import useMarkStepDone from './useMarkStepDone';
import { useNavigate } from 'react-router-dom';
import { onCompletedOnBoarding } from '@/services/on-boarding/onboarding.service';
import { getAuthentication, useAuthentication } from '@/hooks/useAuthentication';

export const useOnBoardingV5 = (step: number) => {
  const { data: onBoardingData, error } = useSuspenseQuery<OnBoardingQuery, OnBoardingQueryVariables>(
    QUERY_ONBOARDING,
    {
      fetchPolicy: 'cache-first',
    },
  );
  const navigate = useNavigate();

  const { markStepDone } = useMarkStepDone();
  const { toggleOnboardingStatus } = useAuthentication();

  const steps = [
    onBoardingData.step1,
    onBoardingData.step2,
    onBoardingData.step3,
    onBoardingData.step4,
    onBoardingData.step5,
  ];

  const currentStep = steps[step - 1];

  const completeStep = async (url?: string) => {
    const nextUrl = url ? url : currentStep?.content?.button?.link || '#';
    markStepDone(nextUrl);

    if (nextUrl === '/') {
      toggleOnboardingStatus('onboardHomeCompleted');
      window.location.href = nextUrl;
      return;
    }

    navigate(nextUrl);
  };

  const onClickOnBoardingCompleted = async () => {
    const { user } = getAuthentication();
    if (!user) return;
    await onCompletedOnBoarding(user.id!);
    completeStep();
  };

  return {
    page: onBoardingData.onBoardingPage,
    steps,
    step,
    step4: onBoardingData?.step4 as Step4,
    currentStep,
    error,
    completeStep,
    onClickOnBoardingCompleted,
  };
};
